export const PROJECT_DONATION_COUNT_KEY_PREFIX =
  'payment-success-project-donation-count';

export const PROJECT_DONATIONS_BEFORE_HIDE_PULSE = 5;

export function getProjectDonationCountKey(userId) {
  if (!userId) {
    return null;
  }

  return `${PROJECT_DONATION_COUNT_KEY_PREFIX}-${userId}`;
}

export function getProjectDonationCount(userId) {
  if (!import.meta.client) {
    return 0;
  }

  const key = getProjectDonationCountKey(userId);

  if (!key) {
    return 0;
  }

  const raw = localStorage.getItem(key);
  const count = Number.parseInt(raw, 10);

  return Number.isNaN(count) ? 0 : count;
}

export function incrementProjectDonationCount(userId) {
  if (!import.meta.client) {
    return 0;
  }

  const key = getProjectDonationCountKey(userId);

  if (!key) {
    return 0;
  }

  const nextCount = getProjectDonationCount(userId) + 1;

  localStorage.setItem(key, String(nextCount));

  return nextCount;
}

export function shouldHidePulseByProjectDonationCount(count) {
  return count >= PROJECT_DONATIONS_BEFORE_HIDE_PULSE;
}

export function recordProjectDonationSuccess(userId) {
  const countBefore = getProjectDonationCount(userId);
  const shouldHidePulse = shouldHidePulseByProjectDonationCount(countBefore);

  incrementProjectDonationCount(userId);

  return shouldHidePulse;
}
